import { render, staticRenderFns } from "./editRateTable.vue?vue&type=template&id=73e18b65&scoped=true"
import script from "./editRateTable.vue?vue&type=script&lang=js"
export * from "./editRateTable.vue?vue&type=script&lang=js"
import style0 from "./editRateTable.vue?vue&type=style&index=0&id=73e18b65&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73e18b65",
  null
  
)

export default component.exports